import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { TrackJS } from 'trackjs';

import { App } from './App';
import { TIGHT_KNIT_ENV, TIGHT_KNIT_TRACKJS_APP_KEY } from './Config/Environment';
import { unregister } from './util/registerServiceWorker';

if (TIGHT_KNIT_ENV !== 'local') {
    TrackJS.install({
        token: '2cc984853eef41f99bfa10755d62ad51',
        application: TIGHT_KNIT_TRACKJS_APP_KEY
        // for more configuration options, see https://docs.trackjs.com
    });
}

unregister(); // This can be removed after the service-worker has been purged from everyone's system. Afterwards, if anyone still has it, they'll need to remove it manually.
ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);



// WEBPACK FOOTER //
// ./src/index.tsx